type Props = {
  children: React.ReactNode;
  when: boolean;
};

export default function Visible({ children, when }: Props) {
  if (when) {
    return <>{children}</>;
  }

  return null;
}
